'use strict';

angular.module('magtac')
  .controller('BulkTasksManagementCtrl', [
    '$scope', 'bulkTasksManagementViewModel',
    function ($scope, viewModel) {
      $scope.model = new viewModel();
    }
  ]);
